import React from "react";
import { Outlet } from "react-router-dom";
import AppHeader from "../LandingPage/AppHeader/AppHeader";
import CustomFooter from "../../components/common/Footer";

const DastakLayout = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <AppHeader />

      <main style={{ flex: 1 }}>
        <Outlet />
      </main>

      <CustomFooter />
    </div>
  );
};

export default DastakLayout;